const ON_CHANGE_DEBOUNCE_TIMER = 300

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChangeStart: "variant-change-start",
  variantChange: "variant-change",
  cartError: "cart-error",
  sectionRefreshed: "section-refreshed",
}
const API_KEY = {
  privateAppKey: "62414b06e09d537c93be14f644e73c81",
}
const SECTION_REFRESH_RESOURCE_TYPE = {
  product: "product",
}
